<template>
  <!-- 患者対応 -->
  <div id="AppSupportListResult">
    <div class="columns">
      <div class="column" style="text-align: left">
        <b-button
          class="button is-primary has-text-centered"
          icon-left="calendar-plus"
          native-type="button"
          :disabled="!patient"
          @click="showSupportHistory()"
        >
          患者対応追加
        </b-button>
        <b-button
          class="button is-primary has-text-centered"
          native-type="button"
          @click="showSupportContentsTemplate()"
        >
          テンプレート管理
        </b-button>
        <b-button
          class="button is-primary has-text-centered"
          native-type="button"
          v-if="this.userInfo.roleId === 1"
          @click="showSupportCategory()"
        >
          カテゴリ管理
        </b-button>
      </div>

      <div class="column">
        <div class="columns">
          <div class="column">
            <b-field label="対応内容" labelPosition="on-border">
              <b-input
                v-model="searchSupportContent"
                name="supportContents"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              :disabled="!patient"
              @click="search()"
            >
              検索する
            </b-button>
          </div>
        </div>
      </div>

      <div class="column is-3">
        <b-field
          horizontal
          label="表示件数"
          style="float: right; white-space: nowrap"
        >
          <b-select position="is-right" v-model="perPage">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </b-select>
        </b-field>
      </div>
    </div>

    <div v-if="patient" class="columns">
      <div class="column" style="text-align: left; border: solid">
        {{ "患者コード：" + patient.patientCode }}
        {{ "　　患者名：" + patient.patientName }}
      </div>
    </div>

    <div class="columns">
      <div class="column if-full">
        <b-table
          :data="data"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :pagination-size="paginationSize"
          :default-sort-direction="sortOrder"
          :default-sort="sortItem"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          backend-sorting
          @sort="sort"
          @page-change="changePage"
        >
          <template v-if="props.row" slot-scope="props">
            <b-table-column field="callDate" label="受付日時" sortable centered>
              {{ props.row.callDate + " " + props.row.callTime }}
            </b-table-column>
            <b-table-column
              field="categoryCode"
              label="対応内容"
              sortable
            >
              {{ props.row.categoryId | supportCategoryFilter(categories) }}
            </b-table-column>
            <b-table-column field="contents" label="" style="overflow: hidden; max-width: 300px; text-overflow: ellipsis; white-space: nowrap;">
              {{ content(props.row.contents) }}
            </b-table-column>
            <b-table-column
              field="salesOfficeName"
              label="記入者所属"
              sortable
              centered
            >
              {{ props.row.salesOfficeName }}
            </b-table-column>
            <b-table-column
              field="entryStaffName"
              label="記入者"
              sortable
              centered
            >
              {{ props.row.entryStaffName }}
            </b-table-column>
            <b-table-column field="mail" label="メール送信" centered>
              {{ props.row.mail ? "完了" : "" }}
            </b-table-column>
            <b-table-column field="files" label="添付" centered>
              <b-button
                v-if="props.row.files.length"
                class="button is-primary has-text-centered"
                icon-left="mdi mdi-paperclip"
                native-type="button"
                @click="showFiles(props.row.files)"
              ></b-button>
            </b-table-column>
            <b-table-column field="edit" label="参照" centered>
              <b-button
                class="button is-primary has-text-centered"
                icon-left="mdi mdi-checkbox-multiple-blank-outline"
                native-type="button"
                @click="showSupportHistory(props.row)"
              ></b-button>
            </b-table-column>
            <b-table-column field="gtAction" label="患者管理チーム対応" centered>
              <span :style="getGtStatusStyle(props.row)">
                {{ props.row.gtAction.status.name }}
              </span>
              <br>
              <span>
                {{ getGtOperatorName(props.row) }}
              </span>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>

    <!-- 対応記録入力 -->
    <support-modal
      v-model="isShowSupportHistory"
      :patient="patient"
      :supportHistory="selectedSupportHistory"
      @update-support-history="search()"
      @update-gt-action="updateGtAction($event)"
    />

    <!-- テンプレート登録 -->
    <support-contents-template-modal v-model="isShowSupportContentsTemplate" />

    <!-- カテゴリ管理 -->
    <support-category-modal
      v-if="userInfo.roleId == 1"
      v-model="isShowSupportCategory"
    />

    <!-- 添付一覧 -->
    <files-modal
      v-model="isShowFiles"
      :files="selectedFiles"
      v-on:download-file="downloadFile($event)"
    />
  </div>
</template>

<script>
import AppSupport from "./AppSupport.vue";
import AppSupportContentsTemplateAdmin from "./AppSupportContentsTemplateAdmin.vue";
import AppSupportCategory from "./AppSupportCategory.vue";
import Files from "./common/Files.vue";
import * as subSystemUtil from "../utils/subSystem";
import * as patientUtils from "../utils/patient";

export default {
  name: "AppSupportListResult",
  props: ["patient", "searchConditions"],

  methods: {
    content: function (contents) {
      return contents.substring(0, contents.indexOf(String.fromCharCode(16)));
    },

    showFiles: function (files) {
      this.selectedFiles = files;
      this.isShowFiles = true;
    },

    showSupportHistory: function (supportHistory) {
      this.selectedSupportHistory = supportHistory;
      this.isShowSupportHistory = true;
    },

    showSupportContentsTemplate: function (y) {
      this.isShowSupportContentsTemplate = true;
    },

    showSupportCategory: function (y) {
      this.isShowSupportCategory = true;
    },

    search: function () {
      if (!this.patient) {
        this.data.splice(0);
        return;
      }
      let excuteApi = this.getPatientSupportHistoriesPOST;
      let successCallBack = this.getPatientSupportHistoriesPOSTSuccess;
      let errorCallBack = this.getPatientSupportHistoriesPOSTError;
      // WebAPI Call
      this.apiCall(
        excuteApi,
        successCallBack,
        errorCallBack,
        this.$store.state.subSystem
      );
    },

    // 対応履歴
    getPatientSupportHistoriesPOST: function (client) {
      const apiRes =
        client.apis.apiPatientSupport.getPatientSupportHistoriesPOST({
          body: {
            patientCode: this.patient.patientCode,
            content: this.searchSupportContent,
            hospitalCode: this.searchConditions.hospitalCode,
            hospitalName: this.searchConditions.hospitalName,
            callDateStart: this.searchConditions.startDate,
            callDateEnd: this.searchConditions.endDate,
            limit: Number(this.perPage),
            currentPage: this.currentPage,
            sortBy: this.sortItem,
            sortDisc: this.sortOrder == "desc" ? true : false,
          },
        });
      return apiRes;
    },

    getPatientSupportHistoriesPOSTSuccess: function (result) {
      // 前後のページに空行設定
      const prevPages = Array(this.perPage * (this.currentPage - 1));
      prevPages.fill();
      const nextPageItemNum =
        result.obj.totalCount - this.perPage * this.currentPage;
      const nextPages = Array(nextPageItemNum > 0 ? nextPageItemNum : 0);
      nextPages.fill();
      const data = [...prevPages, ...result.obj.supports, ...nextPages];
      this.data.splice(0);
      for (let row of data) {
        this.data.push(row);
      }
      return;
    },

    getPatientSupportHistoriesPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      return;
    },

    downloadFile: function (file) {
      this.file = file;
      this.downloadS3ApiCall(
        this.getPatientSupportFileGET,
        this.getPatientSupportFileGETError,
        subSystemUtil.SUB_SYSTEMS[file.subsystem]
      );
    },

    getPatientSupportFileGET: function (client) {
      const apiRes = client.apis.apiPatientSupport.getPatientSupportFileGET({
        id: this.file.id,
        patientCode: this.patient.patientCode,
      });
      return apiRes;
    },

    getPatientSupportFileGETError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },

    getPatientSupportHistoryCategories: function (client) {
      const apiRes =
        client.apis.apiPatientSupport.getPatientSupportHistoryCategoriesGET();
      return apiRes;
    },

    getPatientSupportHistoryCategoriesSuccess: function (result) {
      this.categories = result.obj;
      return;
    },

    changePage: async function (page) {
      this.search();
      return;
    },

    sort: async function (field, order) {
      this.sortItem = field;
      this.sortOrder = order;
      this.search();
      return;
    },

    getGtStatusStyle: function (row) {
      const gtStatusStyle = patientUtils.GT_STATUS_RED_LIST.includes(row.gtAction.status.code) ? "color:red" : "";
      return gtStatusStyle;
    },

    getGtOperatorName: function (row) {
      let gtOperatorName;
      switch (row.gtAction.status.code) {
        case patientUtils.GT_STATUS_MAP.inProgress.code:
          gtOperatorName = row.gtAction.startUserName;
          break;
        case patientUtils.GT_STATUS_MAP.actionCompleted.code:
          gtOperatorName = row.gtAction.completeUserName;
          break;
        case patientUtils.GT_STATUS_MAP.remand.code:
          gtOperatorName = row.gtAction.remandUserName;
          break;
      }

      return gtOperatorName;
    },

    updateGtAction: function (gtAction) {
      this.$emit(
        "update-gt-action",
        gtAction
      );
      return;
    }
  },

  created: async function () {
    // カテゴリ選択肢取得
    this.apiCall(
      this.getPatientSupportHistoryCategories,
      this.getPatientSupportHistoryCategoriesSuccess,
      this.showErrorMessage
    );

    return;
  },

  watch: {
    patient: function () {
      this.search();
      return;
    },

    isShowSupportCategory: function () {
      if (!this.isShowSupportCategory) {
        // カテゴリ選択肢取得
        this.apiCall(
          this.getPatientSupportHistoryCategories,
          this.getPatientSupportHistoryCategoriesSuccess,
          this.showErrorMessage
        );
      }
    },

    perPage: function () {
      this.search();
      return;
    },

    isShowSupportHistory: function (newValue, oldValue) {
      if (oldValue && !newValue) {
        this.search();
      }
      return;
    },
  },

  data() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

    return {
      data: [],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      sortOrder: "desc",
      sortItem: "callDate",
      currentPage: 1,
      perPage: 10,
      selectedFiles: null,
      isShowFiles: false,
      selectedSupportHistory: null,
      isShowSupportHistory: false,
      isShowSupportContentsTemplate: false,
      isShowSupportCategory: false,
      userInfo,
      searchSupportContent: "",
      file: null,
      categories: [],
    };
  },

  filters: {
    supportCategoryFilter: function (value, categories) {
      let category = categories.find((elem) => elem.id == value);
      return category.categoryName;
    },
  },

  components: {
    "support-modal": AppSupport,
    "support-contents-template-modal": AppSupportContentsTemplateAdmin,
    "support-category-modal": AppSupportCategory,
    "files-modal": Files,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppSupportListResult.vue